import apiUrl from '../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../../common/PageTrackerHelper';
const moment = require('moment');

export default {
  name: 'CMTApprove',
  components: {
    VueElementLoading,
    Paginate
  },
  mixins: [PageTracker],
  data: function () {
    return {
      fromDate: '',
      toDate: '',
      searchflag: false,
      localuserid: '',
      localusermailid: '',
      pageno: 1,
      pagecount: 0,
      hubname: '',
      ShippingId: '',
      ShipmentData: '',
      selectedItems: [],
      selectAllItems: false,
      hubID: '',
      hubzoneid: '',
      hubList: [],
      hubZoneList: [],
      amount: 0,
      Loading: false,
      localhubdetails: '',
      hubinfo: '',
      CMTApproveLoader: false,
      CMTDeclineLoader: false,
      totalRecords: 0,
      totalSelectedRecords: 0,
      ExportCMTApproveLoaderBtn: false,
      CMTApproveAllRecord: false,
      ExportButton: false,
      Confiemcheckbox: false,
      previewImageModel: false,
      displayImageInBox: '',
      RSCImagepath: '',
      AWBNumbersArray: [],
      validDateRangeFrom: null,
      todaysDate: null,
      txtCFDate: '',
      txtCTDate: '',
      selectedDtpFromDate: null,
      validDateRange: null,
      Vertical: ''
    }
  },
  created: function () {},
  async mounted() {
    let validateUser = await this.validateJwtToken();
    this.getHubZoneList();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.hubinfo = await this.getHubDetailsbyID(this.localuserid, this.localhubdetails);
    //console.log('Mixin is working for :',result);
  },
  methods: {
    //Get HUBZONE list
    getHubZoneList() {
      axios.get(apiUrl.api_url + 'external/gethubzonelist')
        .then((response) => {
          this.hubZoneList = response.data.data;
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        });
    },
    ChangeHubList(obj) {
      this.getHubList(this.hubzoneid);
    },
    //Get RSC HUBNAME List by HubzoneId
    RSCHUbZOneName(event) {
      this.hubID = '';
      this.hubList = [];
      let payload = {
        "hubzoneid": this.hubzoneid
      }
      axios.post(apiUrl.api_url + 'external/RSCList/by/ZoneId', payload)
        .then((response) => {
          if (response.data.code == 200) {
            this.hubList = response.data.data;
          } else {
            this.$alertify.error("RSC Hub List not found");
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        });
    },
    //FromDate ToDate validations
    checkToDate() {
      this.txtCTDate = '';
      this.todaysDate = moment().format('YYYY-MM-DD');
      this.selectedDtpFromDate = moment.utc(this.txtCFDate).format("YYYY-MM-DD").valueOf();
      if (this.txtCFDate > this.todaysDate) {
        this.$alertify.error("Please select less than todays date")
        this.txtCFDate = '';
      } else {
        this.validDateRange = this.selectedDtpFromDate
      }
    },
    checkFromDate() {
      this.validDateRangeFrom = moment.utc(this.txtCTDate).format("YYYY-MM-DD").valueOf();
      if (this.txtCTDate > this.todaysDate) {
        this.$alertify.error("Please select less than todays date")
        this.txtCTDate = '';
      }
    },
    //ShippingId Validations
    onlyNumber: function ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 44) {
        $event.preventDefault();
      }
    },
    //Selected checkbox functions
    calculateselectedcount() {
      this.totalSelectedRecords = this.selectedItems.length
      if (this.totalSelectedRecords > 0) {
        this.Confiemcheckbox = true;
      } else {
        this.Confiemcheckbox = false;
        this.CMTApproveAllRecord = false;
      }
    },
    selectItems(ev) {
      this.selectedItems = [];
      if (ev.target.checked == true) {
        for (let i in this.ShipmentData) {
          this.selectedItems.push(this.ShipmentData[i].NotifyNoInfoShipmentsID.toString());
        }
      }
      this.totalSelectedRecords = this.selectedItems.length
      if (this.totalSelectedRecords > 0) {
        this.Confiemcheckbox = true;
      } else {
        this.Confiemcheckbox = false;
        this.CMTApproveAllRecord = false;
      }
    },
    getPaginationData(pageNum) {
      this.pageno = pageNum;
      this.SearchShipmets();
    },
    searchData() {
      this.ShipmentData = []
      this.CMTApproveAllRecord = false
      this.searchflag = true
      this.pageno = 1
      this.selectedItems = []
      this.totalSelectedRecords = 0
      this.totalRecords = 0
      this.selectAllItems = false
      this.$refs.paginate.selected = 0;
      this.SearchShipmets()
    },
    //Search data function
    SearchShipmets() {
      this.searchflag = true;
      this.Loading = true;
      let payload = {};
      if (this.ShippingId != "") {
        let shipingID = this.ShippingId.split(/[\s,]+/);
        let shipmentReqArray = [];
        $.each(shipingID, (key, shipmentId) => {
          if (shipmentId != '') {
            shipmentReqArray.push(shipmentId.trim())
          }
        })
        payload.ShippingID = shipmentReqArray;
      }
      if (this.txtCFDate) payload.fromDate = this.txtCFDate;
      if (this.txtCTDate) payload.toDate = this.txtCTDate;
      if (this.hubzoneid) payload.HubZoneID = this.hubzoneid;
      if (this.hubID) payload.HubId = this.hubID;
      if (this.Vertical) payload.payload = this.payload;
      payload.offset = this.pageno - 1,
        payload.limit = 50;

      axios.post(apiUrl.api_url + 'shipmentLost/CMTApproval/getCMTSearchShipmentList', payload)
        .then((response) => {
          if (response.data.code == 200) {
            this.Loading = false;
            this.searchflag = true;
            this.ExportButton = true;
            this.ShipmentData = response.data.data;
            let totalRows = response.data.totalCount;
            this.totalRecords = totalRows
            if (totalRows < 50) {
              this.pagecount = 1;
            } else {
              this.pagecount = Math.ceil(totalRows / 50)
            }
          } else if (response.data.code == 204) {
            this.searchflag = false;
            this.ExportButton = false;
            this.Loading = false;
            this.ShipmentData = [];
            this.$alertify.error(response.data.message);
          } else if (response.data.code == 202) {
            this.Loading = false;
            this.ShipmentData = [];
            this.ExportButton = false;
            this.$alertify.error(response.data.message);
          } else {
            this.Loading = false;
            this.ShipmentData = [];
            this.$alertify.error("No Record found");
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        });
    },
    //Download CSV function
    downloadCsv() {
      this.ShipmentData = [];
      this.ExportCMTApproveLoaderBtn = true;
      let payload = {};
      if (this.ShippingId != "") {
        let shipingID = this.ShippingId.split(/[\s,]+/);
        let shipmentReqArray = [];
        $.each(shipingID, (key, shipmentId) => {
          if (shipmentId != '') {
            shipmentReqArray.push(shipmentId.trim())
          }
        })
        payload.ShippingID = shipmentReqArray;
      }
      if (this.txtCFDate) payload.fromDate = this.txtCFDate;
      if (this.txtCTDate) payload.toDate = this.txtCTDate;
      if (this.hubzoneid) payload.HubZoneID = this.hubzoneid;
      if (this.hubID) payload.HubId = this.hubID;
      payload.offset = this.pageno - 1,
        payload.limit = 100;
      payload.isCsvDownload = true

      axios.post(apiUrl.api_url + 'shipmentLost/CMTApproval/getCMTSearchShipmentList', payload)
        .then((response) => {
          if (response.data.code == 200) {
            let csvArrayExportObj = [];
            response.data.data.forEach(function (item) {
              csvArrayExportObj.push({
                "ShippingID": item.ShippingID,
                "Zone": item.CurrentHubZoneName,
                "HubName": item.HubName,
                "Status": item.Status,
                "DebitAmount": item.ApprovalAmt,
                "DebitConcernPerson": item.rscownername,
                "RSCOwnerProof": item.RejectionProofUrls,
                "Reason": item.RejectionReason,
                "LastmodifiedBy": item.LastModifiedBy,
                "LastmodifiedDate": item.LastModifiedDate,
              })
            });
            this.ExportCMTApproveLoaderBtn = false;
            this.exportCsv(csvArrayExportObj);
          } else if (response.data.code == 204) {
            this.ExportCMTApproveLoaderBtn = false;
            this.ShipmentData = [];
            this.$alertify.error("No Record found");
          } else if (response.data.code == 202) {
            this.ExportCMTApproveLoaderBtn = false;
            this.ShipmentData = [];
            this.$alertify.error(response.data.message);
          } else {
            this.ExportCMTApproveLoaderBtn = false;
            this.ShipmentData = [];
            this.$alertify.error(response.data.message);
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        });
    },

    exportCsv(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "CMTApprove_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function (item) {
        ctr = 0;
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          ctr++;
        });
        result += lineDelimiter;
      });
      return result;
    },
    //CMT Approve function
    Approve() {
      if (this.selectedItems.length == 0) {
        this.$alertify.error("please select atleast one Record");
      } else if (this.CMTApproveAllRecord == false) {
        this.$alertify.error("please Confirm Approve");
      } else {
        this.CMTApproveLoader = true
        let payload = {
          "NotifyNoInfoShipmentsID": this.selectedItems,
          "CMTStaus": "Approved",
          "lastmodifiedby": this.localusermailid
        }
        axios.post(apiUrl.api_url + 'lostshipmentinfo/CMTApproval', payload)
          .then((response) => {
            if (response.data.code == 200) {
              this.$alertify.success(response.data.message);
              this.selectedItems = [];
              this.selectAllItems = false;
              this.CMTApproveAllRecord = false;
              this.clear();
            } else {
              this.$alertify.error(response.data.message);
            }
            this.CMTApproveLoader = false
            this.totalSelectedRecords = 0
          })
          .catch((httpException) => {
            this.CMTApproveLoader = false
            this.totalSelectedRecords = 0
            console.error('exception is:::::::::', httpException)
          });
      }
    },
    //CMT Decline function
    Decline() {
      if (this.selectedItems.length == 0) {
        this.$alertify.error("please select atleast one Record");
      } else if (this.CMTApproveAllRecord == false) {
        this.$alertify.error("please Confirm Decline");
      } else {
        this.CMTDeclineLoader = true
        let payload = {
          "NotifyNoInfoShipmentsID": this.selectedItems,
          "CMTStaus": "Rejected",
          "lastmodifiedby": this.localusermailid
        }
        axios.post(apiUrl.api_url + 'lostshipmentinfo/CMTApproval', payload)
          .then((response) => {
            if (response.data.code == 200) {
              this.$alertify.success(response.data.message);
              this.selectedItems = [];
              this.selectAllItems = false;
              this.CMTApproveAllRecord = false;
              this.clear();
            } else {
              this.$alertify.error(response.data.message);
            }
            this.CMTDeclineLoader = false
            this.totalSelectedRecords = 0
          })
          .catch((httpException) => {
            this.CMTDeclineLoader = false
            this.totalSelectedRecords = 0
            console.error('exception is:::::::::', httpException)
          });
      }
    },
    viewProof(RejectionProofUrls) {
      this.isLoading = true
      let payload = {
        "imageKey": RejectionProofUrls
      }
      axios.post(apiUrl.api_url + 'external/rscRejection/getImage', payload)
        .then((response) => {
          if (response.data.code == 200) {
            this.RSCImagepath = response.data.data
            if (this.RSCImagepath != "") {
              this.displayImageInBox = this.RSCImagepath
              this.previewImageModel = true
              this.isLoading = false
            } else {
              this.$alertify.error("Proof Image Not found")
              this.previewImageModel = false
              this.isLoading = false
            }
          } else {
            this.$alertify.error(response.data.message);
          }
        })
    },

    closeModelPreviewImage() {
      this.displayImageInBox = '';
      this.previewImageModel = false
    },

    clear() {
      this.Vertical = '';
      this.getHubZoneList();
      this.fromDate = '';
      this.toDate = '';
      this.hubname = '';
      this.hubzoneid = '';
      this.ShippingId = '';
      this.hubID = '';
      this.searchflag = false;
      this.ExportButton = false;
      this.CMTApproveAllRecord = false
      this.hubList = [];
      this.pageno = 1;
      this.$refs.paginate.selected = 0;
      this.pagecount = 0;
      this.selectedItems = [];
      this.txtCFDate = '';
      this.txtCTDate = '';
      this.errors.clear();
    },
  },
}


// WEBPACK FOOTER //
// ./src/views/components/LOST/CMTApprove/CMTApprove.component.js